<!-- 论文编辑页面 -->
<template>
  <div class="editor" @click="closeyy()">
    <div class="nav">
      <div class="nav_box">
        <div class="navLeft">
          <i class="el-icon-arrow-left back" @click="back()"></i>
          <el-dropdown trigger="click" @command="handleCommand">
            <div class="el-dropdown-link">
              <span>{{ titleval.length > 0 ? titleval : "未命名文件" }}</span>
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </div>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in wrilingList"
                :key="index"
                :class="item.id == id ? 'dropactive lirow' : 'lirow'"
                :command="item.id"
              >
                <div class="item">
                  {{
                    item.title != null && item.title.length > 0
                      ? item.title
                      : "未命名文件"
                  }}
                </div>
                <i v-if="item.id == id" class="el-icon-check"></i>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="text"
            ><img src="/static/images/nav_baocun.png" alt="" srcset=""/>
            文档自动保存 <i class="el-icon-loading" v-show="saveLoading"></i
          ></span>
        </div>
        <div class="navRight">
          <button class="dow" @click="dowWriting()">
            <img
              src="/static/images/nav_output_default.png"
              alt=""
              srcset=""
            />导出
          </button>
          <!-- <img class="userimg" src="/static/images/dow.png" alt="" srcset="" /> -->
          <!-- <button class="login" @click="goLogin()" v-if="isshowtx == null">
                    登录
                </button> -->
          <div class="head-avatar" v-if="isshowtx != null">
            <el-dropdown @command="handleCommandacc">
              <span class="el-dropdown-link">
                <div class="block">
                  <el-avatar
                    :size="40"
                    :src="userinfo.avatarUrl || ''"
                  ></el-avatar>
                </div>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  class="dropdown-ava"
                  style="overflow: hidden; padding-top: 10px"
                >
                  <div class="avatar-l" style="float: left">
                    <el-avatar
                      shape="square"
                      :size="50"
                      :src="userinfo.avatarUrl || ''"
                    ></el-avatar>
                  </div>
                  <div
                    class="avatar-r"
                    style="
                      float: left;
                      margin-left: 10px !important;
                      line-height: 25px !important;
                    "
                  >
                    <div class="avatar-r-name">
                      <!-- {{ userinfo.nickname || "" }}/{{ userinfo.mobile || "" }} -->
                      {{ userinfo.nickname }}
                    </div>
                    <div class="avatar-r-txt" v-show="!userinfo.isVip">
                      未开通会员<span
                        @click="goVip('first')"
                        style="margin-left: 10px; color: #c79757"
                        >开通</span
                      >
                    </div>
                    <div class="avatar-r-txt" v-show="userinfo.isVip">
                      {{ expireTime }}日到期<span
                        @click="goVip('first')"
                        style="margin-left: 10px; color: #c79757"
                        >续费</span
                      >
                    </div>
                  </div>
                </el-dropdown-item>
                <!-- <el-dropdown-item command="/page/Account">账号设置</el-dropdown-item> -->
                <!-- <el-dropdown-item command="/home">退出登录</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div :class="$root.stateType.msg ? 'mgs_golink' : 'noshow'">
      <div style="display: flex; align-items: center">
        正在进行查重，无法编辑论文，
      </div>
      <button @click="cancel()">取消查重</button>
    </div>
    <div :class="mgs_golink ? 'mgs_golink' : 'noshow'">
      <div style="display: flex; align-items: center">
        此为会员才能使用的功能，
      </div>
      <button @click="mgs_golink = false" style="margin-left: 20px">
        <img src="/static/images/tishi_chacha_default.png" alt="" srcset="" />
      </button>
    </div>
    <div :class="mgs_login ? 'mgs_golink' : 'noshow'">
      <div style="display: flex; align-items: center">登录才能使用此功能</div>
    </div>
    <div class="editbox">
      <!-- 打开菜单按钮 -->
      <button class="menubtn" @click="openMenu()">
        <img
          class="userimg"
          src="/static/images/content_left_button_default.png"
          alt=""
          srcset=""
        />
      </button>

      <div class="note_edit">
        <div style="display: flex; width: 100%; justify-content: center">
          <div
            class="edit"
            id="edit_box"
            v-loading="loading"
            element-loading-text="正在为您努力加载论文"
          >
            <!-- <div
              v-show="jc_btn"
              class="jc_btn"
              @click="realDrop"
              :style="'top:' + jc_top + 'px;left:' + jc_left + 'px'"
            >
              <div class="default"></div>
              <button>自动降重</button>
            </div> -->
            <!-- <div
              class="jc_box"
              :style="'top:' + real_Top + 'px;left:' + real_Left + 'px'"
              v-show="real_box && $root.stateType.userInfo.isVip"
            >
              <p v-if="times > 0 && !real_loading">{{ real_text }}</p>
              <p
                v-if="real_loading"
                style="text-align: center; color: #989da2; margin: 30px"
              >
                请在降重<i class="el-icon-loading"></i>
              </p>
              <p
                v-if="times == 0"
                style="text-align: center; color: #989da2; margin: 30px"
              >
                今日降重次数已用完
              </p>
              <div class="row">
                <span
                  >今日降重次数剩余<b>{{ times }}</b
                  >次</span
                >
                <div v-if="times > 0">
                  <button type="button" class="close" @click="closeReal">
                    取消</button
                  ><button class="real_text" @click="realText">替换</button>
                </div>
              </div>
            </div> -->
            <!-- 打开笔记按钮 -->
            <div
              class="open_npte"
              v-if="$root.stateType.isLogin"
              @click="get_note()"
            >
              <img src="/static/images/notes_default.png" alt="" />
            </div>
            <div class="btnrow">
              <button
                class="ounline"
                v-if="titlelist.length == 0"
                @click="getOuline()"
              >
                提纲推荐
              </button>
              <button
                class="ounline"
                style="
                  background: linear-gradient(0deg, #8a8a8a 0%, #a8a8a8 100%);
                "
                v-else
              >
                提纲推荐
              </button>
              <div class="edit_btn">
                <button
                  @click="
                    exec('undo');
                    exec('undo');
                  "
                >
                  <img
                    class="userimg"
                    src="/static/images/writetop_back.png"
                    alt=""
                    srcset=""
                  />
                </button>
                <button
                  @click="
                    exec('redo');
                    exec('redo');
                  "
                >
                  <img
                    class="userimg"
                    src="/static/images/writetop_go.png"
                    alt=""
                    srcset=""
                  />
                </button>
                <span class="shu"></span>
                <button
                  @click="exec('h1')"
                  :class="commandVal == 'h1' ? 'acv' : ''"
                >
                  H<span style="font-sise: 12px">1</span>
                </button>
                <button
                  @click="exec('h2')"
                  :class="commandVal == 'h2' ? 'acv' : ''"
                >
                  H<span style="font-sise: 12px">2</span>
                </button>
                <button
                  @click="exec('h3')"
                  :class="commandVal == 'h3' ? 'acv' : ''"
                >
                  H<span style="font-sise: 12px">3</span>
                </button>
                <button
                  @click="exec('div')"
                  :class="commandVal == 'div' ? 'acv' : ''"
                >
                  正文
                </button>
              </div>
              <div class="fl_left">
                {{ textnum }}字<i class="el-icon--right"></i>
                <!-- <el-dropdown trigger="click" @command="chachong">
                                <span class="el-dropdown-link" v-if="clickacv == 0">
                                    {{ textnum }}字<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <span v-if="clickacv == 1" class="el-dropdown-link"><span class="gou_box"> </span>{{ similarJson.similarWordCount || 0 }}重复字数<span class="miniSize"><i class="el-icon-arrow-down el-icon--right"></i></span></span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="0"><span class="gou_box">
                                            <i class="el-icon-check" v-show="clickacv == 0"></i></span>{{ textnum }}字</el-dropdown-item>
                                    <el-dropdown-item command="1" style="
                        color: #cccccc !important;
                        background: #ffffff !important;
                      "><span class="gou_box" disabled>
                                            <i class="el-icon-check" v-show="clickacv == 1"></i></span>{{ similarJson.similarWordCount || 0 }}重复字数<span class="miniSize"></span><button class="update" @click="up_writing('true')">
                                            <i class="el-icon-refresh-right"></i>更新查重
                                        </button></el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown> -->
              </div>
            </div>
            <div class="content">
              <header>
                <input
                  type="text"
                  placeholder="输入不少于5字标题,开启智能推荐"
                  @click="savetitle()"
                  @blur="hideBtn()"
                  @keyup="inputlength"
                  @focus="showBtn()"
                  @keydown="inputlength"
                  class="title"
                  minlength="5"
                  maxlength="50"
                  id="title"
                  :value="titleval"
                />
                <button
                  class="oulinebtn"
                  :style="'top:' + ofTop + 'px;left:' + ofLeft + 'px'"
                  @click="getOuline()"
                  v-if="btnShow && titlelist.length == 0"
                >
                  推荐提纲
                </button>
              </header>
              <div class="line"></div>
              <!-- 文本编辑器 -->
              <div
                id="editor"
                @keyup="setTag"
                @blur="hideContentBtn()"
                @click="getTag"
                :contenteditable="$root.state.isLogin"
                readonly="readonly"
                @paste.capture="handlePaste"
              ></div>
            </div>
          </div>
          <!-- 笔记 -->
          <note
            ref="note"
            @close_note="close_note"
            :class="show_note ? 'lookW' : 'mosuW'"
            v-show="noteclass"
            @addhtml="addHTML"
            @opendata="opendata"
          ></note>
        </div>
        <!-- 右侧菜单 -->
        <div style="display: flex">
          <div
            :class="rightDrawer == 1 ? 'right_hover' : 'left_hover'"
            @click="openRight()"
          >
            <span class="images_right" v-show="rightDrawer == 1"></span>
            <span class="images_left" v-show="rightDrawer != 1"></span>
            <!-- <img :src="
            rightDrawer == 1
              ? '/static/images/right_hover.png'
              : '/static/images/left_hover.png'
          " alt="" srcset="" /> -->
          </div>
          <div
            :class="rightDrawer == 1 ? 'openrightDrawer' : 'rightDrawer'"
            v-if="rightDrawer != 3"
            v-loading="Rloading"
            :element-loading-text="loadingText"
          >
            <database
              @museDr="museDr"
              @setTitle="setTitle"
              ref="database"
              :title="titleval"
              v-if="rightDrawer_type == 'database'"
            ></database>
            <ideas
              @get_ideas="get_ideas()"
              @addhtml="addHTML"
              v-if="rightDrawer_type == 'ideas'"
              :content="getcontent"
              :listData="thinkingList"
            ></ideas>
            <errorCorrection
              ref="eorr"
              :id="id"
              v-if="rightDrawer_type == 'errorCorrection'"
            ></errorCorrection>
            <ai
              ref="ai"
              @getsummary="getsummary"
              @saveWriting="saveWriting()"
              v-if="rightDrawer_type == 'ai'"
              :ailist="aiList"
              :listData2="listdata2"
              :activeName="aitype"
              :title="titleval"
            ></ai>
            <duplicateCheck
              v-if="rightDrawer_type == 'duplicateCheck'"
              :realId="realId"
              @gethtml="initData"
              :title="titleval"
              ref="duplicateCheck"
              :id="id"
              @golist="golist"
            ></duplicateCheck>
            <duplicate
              v-if="rightDrawer_type == 'duplicate'"
              @get_check="get_check"
              :checklistData="checklistData"
              @golist="golist"
              @backlist="backlist"
            ></duplicate>
          </div>

          <div class="menuRight" :style="rightDrawer != 1 ? 'z-index:999' : ''">
            <div @click="open_rightDrawer('database')">
              <div class="Right_icon_box">
                <img
                  src="/static/images/dataswarehouse_default.png"
                  :class="isClass?'isClassOn':''"
                  v-if="rightDrawer_type != 'database'"
                  alt=""
                  srcset=""
                />
                <img
                  src="/static/images/dataswarehouse_hover.png"
                  v-else
                  :class="isClass?'isClassOn':''"
                  alt=""
                  srcset=""
                />
              </div>
              <p id="fouer">资料库</p>
            </div>
            <div @click="open_rightDrawer('ideas')">
              <div class="Right_icon_box">
                <img
                  src="/static/images/recommend_default.png"
                  v-if="rightDrawer_type != 'ideas'"
                  :class="isClass?'isClassOn':''"
                  alt=""
                  srcset=""
                />
                <img
                  src="/static/images/recommend_hover.png"
                  v-else
                  alt=""
                  srcset=""
                />
              </div>
              <p>推荐思路</p>
            </div>
            <div @click="open_rightDrawer('duplicateCheck')" id="checkBtn">
                <div class="Right_icon_box">
                    <img src="/static/images/chachong_default.png" v-if="
                      rightDrawer_type != 'duplicateCheck' &&
                      rightDrawer_type != 'duplicate'
                     "
                     :class="isClass?'isClassOn':''"
                     alt="" srcset="" />
                    <img src="/static/images/chachong_hover.png" v-if="
                      rightDrawer_type == 'duplicate' ||
                      rightDrawer_type == 'duplicateCheck'
                    " alt="" srcset="" />
                          </div>
                <p>实时查重</p>
            </div>
            <div @click="open_rightDrawer('errorCorrection')">
              <div class="Right_icon_box">
                <img
                  src="/static/images/mistakes_default.png"
                  v-if="rightDrawer_type != 'errorCorrection'"
                  :class="isClass?'isClassOn':''"
                  alt=""
                  srcset=""
                />
                <img
                  src="/static/images/mistakes_hover.png"
                  v-else
                  alt=""
                  srcset=""
                />
              </div>

              <p>论文纠错</p>
            </div>
            <div @click="open_rightDrawer('ai')">
              <div class="Right_icon_box">
                <img
                  src="/static/images/auto_default.png"
                  v-if="rightDrawer_type != 'ai'"
                  :class="isClass?'isClassOn':''"
                  alt=""
                  srcset=""
                />
                <img
                  src="/static/images/auto_hover.png"
                  v-else
                  alt=""
                  srcset=""
                />
              </div>

              <p>摘要致谢</p>
            </div>
          </div>
        </div>
      </div>
      <button
        class="oulinebtn"
        :style="'top:' + cofTop + 'px;left:' + cofLeft + 'px'"
        @click="thinking()"
        v-show="edit_btnShow"
      >
        推荐思路
      </button>

      <!-- 左侧侧边栏 推荐提纲&&标题 -->
      <div
        :class="
          menuDrawer == 1
            ? 'openmenuDrawer'
            : menuDrawer == 2
            ? 'menuDrawer'
            : ''
        "
        v-loading="ouline_loading"
        v-if="menuDrawer == 1"
        element-loading-text="正在努力为您生成提纲"
        customClass="menutext"
      >
        <div class="menu_box" v-if="ouline_type">
          <div class="menu_row">
            <span>目录</span
            ><span @click="menuDrawer = 2"
              ><img
                class="userimg"
                src="/static/images/content_chacha_default.png"
                alt=""
                srcset=""
            /></span>
          </div>
          <hr class="menu_hr" />
          <div class="titlelist" id="titlelist" v-show="titlelist.length != 0">
            <ul>
              <li
                @click="jump(item.id)"
                :class="item.localName"
                v-for="(item, index) in titlelist"
                :key="index"
              >
                {{ item.content }}
                <button
                  v-if="item.content == '摘要' || item.content == 'Abstract'"
                  class="ai_btn"
                  @click="getsummary('1')"
                >
                  智能生成</button
                ><button
                  v-if="item.content == '致谢'"
                  class="ai_btn"
                  @click="getsummary('2')"
                >
                  智能生成
                </button>
              </li>
            </ul>
          </div>
          <div class="no_title" v-show="titlelist.length == 0">
            <p>添加标题后会在这里自动生成目录</p>
            <h5>没有思路？试试：</h5>
            <button @click="getOuline()">提纲推荐</button>
          </div>
        </div>
        <div class="oulinebox" v-if="!ouline_type">
          <div class="menu_row">
            <span></span
            ><span @click="menuDrawer = 2"
              ><img
                class="userimg"
                src="/static/images/content_chacha_default.png"
                alt=""
                srcset=""
            /></span>
          </div>
          <ouline
            :title="titleval"
            :keywords="keywords"
            @saveOutline="downLeft"
            @getOutline="getOuline"
            :outline="outlineList"
          ></ouline>
        </div>
      </div>
    </div>
    <RechargePop :visible.sync="dialogVisible" :tabName="rechargeTabName"></RechargePop>
    <!-- 成功弹窗 -->
    <el-dialog :visible.sync="vipPop" width="430px" center>
        <div class="modifyM-box" style="text-align: center; width:370px;height:183px">
            <div class="vip-suc">
                <img src="../../../static/images/acc_state_sucess.png" alt=""/>
                <p style="margin-top:32px;font-size:17px;color:#333439;font-weight:bold">支付成功</p>
            </div>
        </div>
    </el-dialog>

     <div class="limit-open-vip">
        <el-dialog
          :close-on-click-modal= "false"
          :visible.sync="opneVipVisible"
          width="500px"
          top="30vh"
          title="导出论文">
          <div class="open-vip-box">
            <div class="open-vip-box-message">今日2次导出机会已用完，开通会员继续享受</div>
            <button
                @click="goVip('first')"
                class="check-glod-btn"
                style="margin-right:16px"
              >
                <span class="check-btn-text">开通会员</span>
              </button>
          </div>
        </el-dialog>
     </div>
  </div>
</template>

<script>
import ideas from "@/components/writing/ideas";
import database from "@/components/writing/database"; //资料库
import ouline from "@/components/writing/ouline"; //推荐提纲
import errorCorrection from "@/components/writing/errorCorrection"; //论文纠错
import ai from "@/components/writing/ai"; //智能生成
import duplicateCheck from "@/components/writing/duplicateCheck"; //实时查重
import duplicate from "@/components/writing/duplicate";
import RE from "./richeditor";
import note from "@/components/writing/note";
import RechargePop from "@/components/recharge/rechargePop.vue";

export default {
  data: function() {
    return {
      saveTime: "",
      listdata2: [],
      saveLoading: false,
      ouline_type: false,
      menuDrawer: 3,
      show: 0,
      clickacv: 0,
      mgs_login: false,
      loading: false,
      ofTop: -1000,
      ofLeft: 0,
      cofTop: -5000,
      cofLeft: 0,
      rightDrawer: 3,
      thinkingtype: "zy",
      thinkingList: [],
      titleval: "",
      commandVal: "p",
      active: 0,
      edit_btnShow: false,
      listData: [{}, {}],
      titlelist: [],
      aiList: [],
      ouline_loading: false,
      Rloading: false,
      rightDrawer_type: "database",
      getcontent: "",
      content: "",
      loadingText: "",
      lastServerUpdateTime: "",
      settitle: "",
      btnShow: false,
      outlineList: [],
      mgs_golink: false,
      keywords: [],
      wrilingList: [],
      aitype: "1",
      textnum: 0,
      checkpage: {
        articleId: "",
        size: 10,
        current: 1
      },
      checklistData: {},
      id: "",
      noteclass: false,
      show_note: false,
      jc_btn: false,
      jc_top: 100,
      jc_left: 100,
      getccType: "",

      // 顶部个人中心
      isshowtx: localStorage.getItem("token"),
      userinfo: {},
      // vip到期时间
      expireTime: "2020-10-30",
      jc_ben: "",
      realContent: "",
      realId: "",
      real_box: false,
      real_text: "",
      real_Top: -1000,
      real_Left: -1000,
      times: 10,
      real_loading: false,
      undo: [],
      similarJson: {},
      xyTime: "",
      exportTimes: 0, //导出次数
      dialogVisible: false,
      vipPop: false,
      guideShow: false,
      localName: "",
      opneVipVisible: false,
      rechargeTabName: 'first',

      isClass:false

    };
  },
  components: {
    database,
    ouline,
    ideas,
    errorCorrection,
    ai,
    duplicateCheck,
    duplicate,
    note,
    RechargePop
  },
  mounted: function() {
    setTimeout(() => {
      RE.init();
    }, 500);
  },
  created: function() {
    this.getUserInfo();
    this.getGuideLimit();
    this.id = this.$route.query.id;
    this.initData();
    this.getWritineList();
    // this.getExportTimes();
    //this.up_writing();
  },
  methods: {
    /** 获取用户信息 */
    getUserInfo() {
      if (this.$root.stateType.isLogin) {
        this.oauthapi.userInfo().then(res => {
          if( res.code == 0) {
            this.$root.stateType.userInfo = res.data;
            this.userinfo = res.data;
            if (this.userinfo != null && this.userinfo.expireTime != null) {
              this.expireTime = this.userinfo.expireTime.split(" ")[0] || "";
              localStorage.setItem("userinfo", JSON.stringify(res.data));
            }
          }
        });
      }
    },

    /**
     * 取消查重
     */
    cancel() {
      this.api
        .cancel({
          articleId: this.id
        })
        .then(res => {
          this.loading = false;
          clearTimeout(this.checkTime);
          this.$root.stateType.msg = false;
          this.$root.stateType.cctext =
            "已经取消实时查重，请到查重记录当中查看查重结果";
          document
            .getElementById("editor")
            .setAttribute("contenteditable", "true");
        });
    },
    /**
     * 点击更新笔记
     */
    get_note() {
      this.show_note = true;
      (this.noteclass = true),
        this.rightDrawer == 1 ? (this.rightDrawer = 2) : "";
      this.$refs.note.initData();
    },
    /**
     * 查重替换
     */
    realText() {
      if (this.real_loading) {
        return false;
      }
      var real = document.getElementById("a" + this.realId);
      real.innerHTML = "";
      let outer = `<a class="yesreal">${this.real_text}</a>`;
      real.outerHTML = outer;
      this.saveWriting();
      this.real_box = false;
      //document.getElementById("a" + this.realId).innerText = this.realContent
    },
    /**
     * 自动降重
     */
    realDrop(event) {
      console.log(this.$root.stateType.userInfo.isVip);
      if (!this.$root.stateType.userInfo.isVip) {
        this.mgs_golink = true;
        setTimeout(() => {
          this.mgs_golink = false;
        }, 2000);
        return false;
      }
      if (this.times == 0) {
        this.real_text = "今日降重次数已用完";
        this.times = 0;
        return false;
      }
      this.real_box = true;
      this.real_text = "";
      this.real_Top = this.jc_top - 20;
      this.real_Left = this.jc_left - 180;
      this.real_loading = true;
      this.api
        .realDrop({
          content: this.realContent
        })
        .then(res => {
          this.real_loading = false;
          if (res.code == 2000) {
            this.mgs_golink = true;
            setTimeout(() => {
              this.mgs_golink = false;
            }, 2000);
          }
          if (res.code == 2002) {
            this.real_text = res.msg;
            this.times = 0;
          }
          if (res.code == 0) {
            this.real_text = res.data.content;
            this.times = res.data.times;
          }
          if (res.code == 500) {
            this.real_text = res.data.content;
            this.times = res.data.times;
          }
        });
    },
    closeReal() {
      this.real_Top = -1000;
    },
    get_check() {
      this.rightDrawer = 1;
      this.rightDrawer_type = "duplicateCheck";
      setTimeout(() => {
        this.$refs.duplicateCheck.listInit();
      }, 200);
    },
    /**
     *点击登录
     */
    goLogin: function() {
      this.$router.push({
        name: "login",
        query: {
          path: this.$route.path,
          params: this.$route.params,
          query: this.$route.query
        }
      });
    },
    closeyy() {
      if (this.rightDrawer_type != "database") {
        return false;
      }
      var selection = window.getSelection();
      if (selection.baseOffset == selection.focusOffset) {
        this.$root.stateType.show_ab_btn = false;
      }
    },
    // 跳转至会员中心
    goVip(tabName) {
      // this.oauthapi.vipRedirectUrl().then(res => {
      //   if (res.code == 0) {
      //     window.open(res.data.attributeValue, "_blank");
      //   }
      // });
      this.opneVipVisible  = false;
      this.dialogVisible = true;
      if(tabName) {
        console.log(tabName)
        this.rechargeTabName = tabName;
      }else{
        this.rechargeTabName = 'first';
      }
    },
    // 账号设置
    handleCommandacc(command) {
      if (command == "/page/Account") {
        this.$router.push(command);
      } else if (command == "/home") {
        localStorage.clear();
        location.reload();
        this.$router.push(command);
      }
    },

    /**
     * 打开资料库
     */
    opendata: function(id) {
      this.rightDrawer_type = "database";
      this.rightDrawer = 1;
      this.show_note = false;
      setTimeout(() => {
        this.$refs.database.openPage(id);
      }, 200);
    },
    dowWriting() {
      if (this.id == "Examples") {
        return false;
      }
      this.api.getToolsLimitCheck({type: 2}).then(res => {
        if (res.code == 0) {
          this.api.dowWriting(this.id);
        } else {
          this.opneVipVisible = true;
        }
      })
    },

    close_note: function() {
      this.show_note = false;
    },
    downLeft() {
      this.menuDrawer = 3;
      this.gettitle();
    },
    /**
     * 论文实时查重
     */
    setTitle: function(value) {
      this.titleval = value;
    },
    /**
     * 推荐摘要/致谢
     */
    getsummary: function(i) {
      this.rightDrawer_type = "ai";
      this.rightDrawer = 1;
      this.aitype = i;
      if (i == 1) {
        this.$root.stateType.aiAbstract = true;
      }
      if (i == 2) {
        this.$root.stateType.aithank = true;
      }
      setTimeout(() => {
        this.$refs.ai.activeNames = i;
      }, 100);
      if (!this.$root.stateType.isLogin) {
        console.log(this.$root.stateType.mocke);
        this.aiList = [];
        this.listdata2 = this.$root.stateType.mocke.zx;
        this.$root.stateType.aiAbstract = false;
        this.$root.stateType.aithank = false;
        return false;
      }
      this.api
        .getsummary({
          title: this.titleval,
          type: i
        })
        .then(res => {
          this.$root.stateType.aiAbstract = false;
          this.$root.stateType.aithank = false;
          if (i == 1) {
            this.aiList = res.data;
          }
          if (i == 2) {
            this.listdata2 = res.data;
          }
        });
    },

    /**
     * 添加推荐思路到正文
     */
    addHTML: function(data) {
      if (!this.$root.stateType.isLogin) {
        this.$message({
          message: "此功能登录才能使用",
          type: "warning"
        });
        return false;
      }
      document.getElementById("editor").focus();
      RE.reduceRange();
      var selection = window.getSelection();
      console.log(selection);
      RE.reduceRange();
      if (document.getElementById("foucr")) {
        document.getElementById("foucr").outerHTML = document.getElementById(
          "foucr"
        ).innerHTML;
      }
      if (selection.focusNode.id == "editor" || this.commandVal != "div") {
        this.$message("请点击正文");
        return false;
      }
      RE.saveRange();
      RE.insertHtml('<a id="foucr">' + data + "</a>");
      var span = document.getElementById("foucr");
      span.setAttribute("style", "color:#000000");
      var range = document.createRange();
      range.selectNodeContents(span);

      selection.removeAllRanges();
      selection.addRange(range);
      console.log(document.getElementsByClassName("content")[0].scrollTop);

      const downloadEle = document.querySelector("#foucr");
      if (!!downloadEle) {
        downloadEle.scrollIntoView(true); // true 是默认的
      }
      document.querySelector(".content").scrollIntoView(true);
      if (document.getElementsByClassName("content")[0].scrollTop > 200) {
        document.getElementsByClassName("content")[0].scrollTop += 50;
      }
      //更新字数
      this.textnum = document.getElementById("editor").innerText.length;
      this.$message({
        message: "导入成功",
        type: "success"
      });
      this.saveWriting();
    },

    /**
     * 推荐思路
     */
    thinking: function() {
      if (this.titleval == "") {
        this.$message({
          message: "请输入不少于5字标题再试",
          type: "warning"
        });
        return false;
      }
      this.show_note = false;
      this.thinkingList = [];
      // if (!window.getSelection().focusNode.nodeValue) {
      //     console.log(1)
      //     return false
      // }
      this.rightDrawer = 1;
      this.rightDrawer_type = "ideas";

      if (
        window.getSelection().focusNode.id &&
        window.getSelection().focusNode.id == "editor"
      ) {
        return false;
      }

      this.Rloading = true;
      // if (
      //     window.getSelection().focusNode.parentNode.previousSibling.localName ==
      //     "div"
      // ) {
      //     this.getfrom(
      //         window.getSelection().focusNode.parentNode.previousSibling
      //     );
      // }
      let type = 1;
      this.content = document.getSelection().focusNode;

      this.localName = "";

      if (this.content.textContent.length != 0&&this.content.innerHTML != "<br>") {
        this.getcontent = this.content.textContent.slice(0, this.focusOffset);
        this.localName = this.content.localName;

      }
      if (this.content.textContent.length == 0) {
        if (!this.content.previousSibling || this.content.previousSibling == null) {
          this.getcontent = this.titleval;
          this.localName = "";
        } else {
          if (
            this.content.previousSibling.innerText.length != 0 &&
            this.content.previousSibling.innerHTML != "<br>"
          ) {
            this.getcontent = this.content.previousSibling.innerText;
            this.localName=this.content.previousSibling.localName
          } else {
            this.getContentVal(this.content.previousSibling);
          }
        }
      }
      if(this.localName == "h1" || this.localName == "h2" || this.localName == "h3"
        || this.localName == "h4" || this.localName == "h5"){
        type = 2;
      }
      this.api
        .getThinking({
          title: this.titleval,
          content: this.getcontent,
          type: type
        })
        .then(res => {
          this.Rloading = false;
          this.thinkingList = res.data;
        });
    },
    getContentVal(dom) {
      console.log(111)
      if (!dom.previousSibling) {
        this.getcontent = this.titleval;
        this.localName=''
        return false;
      }
      if (dom.innerText.length != 0 && dom.innerHTML != "<br>") {
        this.getcontent = dom.innerText;
        this.localName=dom.localName
      } else {
        this.getContentVal(dom.previousSibling);
      }
    },
    /**
     * 推荐思路
     */
    get_ideas: function() {
      this.thinking();
      this.loadingText = "正在努力为您生成推荐思路";
    },
    /**
     * 查找当前标题下到光标的所有字符
     */
    getfrom: function(dom) {
      this.getcontent = dom.innerText + this.getcontent;
      if (!dom.previousSibling) {
        return false;
      }
      if (dom.previousSibling.id) {
        return false;
      }
      if (dom.previousSibling.localName == "div") {
        this.getfrom(dom.previousSibling);
      } else {
        this.Rloading = false;
        this.getcontent = "";
      }
    },
    returnValue(event) {
      console.log(event);
    },
    /**
     * 第一次打开侧边栏
     */
    openRight: function() {
      this.show_note = false;
      this.rightDrawer == 1 ? (this.rightDrawer = 2) : (this.rightDrawer = 1);
      if (this.rightDrawer_type == "database" && this.rightDrawer == 1) {
        //资料库
        setTimeout(() => {
          this.$refs.database.initData();
        }, 300);
      }
      if (this.rightDrawer_type == "ideas") {
        //智能推荐
        // this.get_ideas();
      }
      if (
        this.rightDrawer_type == "errorCorrection" &&
        this.rightDrawer == 1 &&
        this.$refs.eorr
      ) {
        //纠错
        this.$refs.eorr.correctList();
      }
      if (
        this.rightDrawer_type == "duplicateCheck" &&
        this.rightDrawer == 1 &&
        this.$refs.duplicateCheck
      ) {
        this.$refs.duplicateCheck.initData();
      }
    },
    museDr: function() {
      this.rightDrawer = 2;
    },

    /**
     * 锚点跳转
     */
    jump: function(id) {
      const downloadEle = document.querySelector("#" + id);
      if (!!downloadEle) {
        downloadEle.scrollIntoView(true); // true 是默认的
      }
      document.querySelector("#titlelist").scrollIntoView(true);
    },

    /**
     * 论文查重
     */
    chachong: function(command) {},
    /**
     *获取论文列表
     */
    getWritineList: function() {
      if (!this.$root.stateType.isLogin) {
        return false;
      }
      this.api
        .getWritinglist({
          size: 5,
          current: 1
        })
        .then(res => {
          this.wrilingList = res.data.records;
        });
    },
    /**
     * 切换论文
     */
    handleCommand: function(command) {
      this.id = command;
      this.rightDrawer = 3;
      this.menuDrawer = 3;
      let newQuery = JSON.parse(JSON.stringify(this.$route.query));
      newQuery.id = command;
      this.$router.replace({
        query: newQuery
      });
      this.initData();
    },

    handleClose: function(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    /**
     * 返回上一页
     */
    back: function() {
      //this.$router.back();
      this.$router.replace("/page/writing");
    },
    /**
     * 插入标签
     */
    exec: function(tag) {
      var selection = window.getSelection();
      /*if (this.commandVal == tag) {
                return false;
            }*/
      this.commandVal = tag;
      document.getElementById("shu")
        ? document.getElementById("shu").remove()
        : "";
      RE.exec(tag);
      document.getElementById("editor").focus();
      this.saveWriting();
    },
    getTag: function(event) {
      this.commandVal = document.queryCommandValue("formatBlock");
      if (window.getSelection().focusNode.nodeValue == "") {
        return false;
      }
      this.jc_btn = false;

      if (event.target.className == "similar") {
        RE.saveRange();
        if (event.target.id != "a" + this.realId) {
          this.real_box = false;
        }
        this.show_note = false;
        this.rightDrawer = 1;
        this.edit_btnShow = false;
        this.rightDrawer_type = "duplicateCheck";
        this.realContent = event.target.innerText;
        this.realId = event.target.id.split("a")[1];
        var c_top = document.getElementsByClassName("content")[0].scrollTop;
        var editor = document.getElementById("edit_box");
        this.jc_top = event.clientY - editor.offsetTop - editor.offsetTop - 150;
        this.jc_btn = true;
        setTimeout(() => {
          this.$refs.duplicateCheck.initData();
        }, 200);

        this.jc_left = event.clientX - 47 - editor.offsetLeft;

        RE.reduceRange();
      }
      this.getxy();
    },
    /**
     * 获取光标的位置 标题
     */
    reduceRange: function() {
      var span = document.createElement("span");
      span.setAttribute(
        "style",
        "position: absolute;font-size: 28px;word-break: keep-all;font-weight: bold;"
      );
      var selectionstar = document.getElementById("title").selectionStart;
      var selection = document.getElementById("title").selectionEnd;
      var fontW = document.getElementById("title").value.slice(0, selection);
      span.innerText = fontW;
      document.getElementsByTagName("body")[0].appendChild(span);
      let spanleft = span.offsetWidth;
      span.remove();
      var scrollleft = window.getSelection().focusNode.firstElementChild
        .scrollLeft;
      var scrollWidth = window.getSelection().focusNode.firstElementChild
        .scrollWidth;

      this.ofTop = document.getElementById("title").offsetTop + 40;
      this.ofLeft =
        document.getElementById("title").offsetLeft + 5 + spanleft - scrollleft;
    },

    // set_btn: function (event) {
    //     if (window.getSelection().focusNode.nodeValue == '') {
    //         return false
    //     }
    //     setTimeout(() => {
    //         this.commandVal =
    //             window.getSelection().focusNode.localName ||
    //             window.getSelection().focusNode.parentNode.localName;
    //     }, 100);
    //     var selection = document.getElementById("editor").selectionEnd;
    //     this.getxy();
    // },
    /**
     * 失去焦点隐藏按钮
     */
    hideContentBtn: function() {
      setTimeout(() => {
        this.edit_btnShow = false;
        this.jc_btn = false;
      }, 200);
    },
    /**
     * 鼠标经过定位降重按钮
     */
    getcc(event) {
      if (event.target.className == "similar") {
      }
    },

    /**
     * 获取编辑器当前的标签状态添加按钮 光标按钮
     */
    getxy: function(event) {
      this.commandVal = document.queryCommandValue("formatBlock");
      var selection = window.getSelection();
      if (document.queryCommandValue("formatBlock") == "") {
        this.commandVal = selection.baseNode.parentNode.localName;
      }

      var c_top = document.getElementsByClassName("content")[0].scrollTop;
      var editor = document.getElementById("edit_box");
      var Oleft = editor.offsetLeft;
      if (selection.focusNode.id == "refExport") {
        return false;
      }
      if (
        document.getElementById("editor").getAttribute("contenteditable") ==
        "false"
      ) {
        return false;
      }
      if (selection.focusNode.parentNode.className == "similar") {
        if (
          this.similarJson.similarJson[this.realId].sentence !=
          selection.focusNode.data
        ) {
          selection.focusNode.parentNode.setAttribute("class", "yesreal");
        }
      }

      if (
        this.commandVal == "p" ||
        selection.focusNode.id == "editor" ||
        selection.focusNode.parentNode.className == "similar" ||
        // 解除提纲没有推荐思路按钮的跟随限制
        //this.commandVal != "div" ||
        !this.$root.stateType.isLogin
      ) {
        this.edit_btnShow = false;
        return false;
      } else {
        this.edit_btnShow = true;
        this.jc_btn = false;
      }
      var fontW = selection.focusNode.parentNode.innerText.slice(
        0,
        selection.anchorOffset
      );
      this.getcontent = fontW;
      if (selection.isCollapsed) {
        clearTimeout(this.xyTime);
        this.xyTime = setTimeout(() => {
          document.execCommand("insertHtml", false, '<i id="shu">&#8302</i>');
          this.cofLeft = Oleft + selection.focusNode.parentNode.offsetLeft;
          this.cofTop = selection.focusNode.parentNode.offsetTop - c_top + 20;

          document.getElementById("shu").remove();
          //selection.focusNode.parentNode.normalize() //合并文本节点  防止发生断点
        }, 50);
      }
    },
    /**
     * 标题获得焦点的时候获取一下光标 并显示按钮
     */
    showBtn: function() {
      this.btnShow = true;
      if (this.titleval.length < 5) {
        this.btnShow = false;
      } else {
        //this.saveWriting();
      }
      // 标题及时不足5字，也需保存
      this.saveWriting();
    },
    async getmock() {
      var mocke = await import("../../../static/js/mocdata");
      return mocke.default;
    },
    hideBtn: function() {
      setTimeout(() => {
        this.btnShow = false;
      }, 200);
    },
    /**
     * 监听输入编辑器 间隔1秒保存一次
     */
    setTag: function(event) {
      this.textnum = document.getElementById("editor").innerText.length;
      this.saveWriting();
      if (event.code == "Enter" || event.code == "Backspace") {
        this.commandVal = window
          .getSelection()
          .getRangeAt(0).startContainer.localName;
      }
      if (window.getSelection().focusNode.nodeValue == "") {
        return false;
      }
      this.getxy(event);
    },
    /**
     *监听标题的输入 间隔1秒钟保存一次
     */
    savetitle: function() {
      this.showBtn();
      this.reduceRange();
    },
    /**
     * 控制标题输入框的推荐提纲按钮显示
     */
    inputlength: function(val) {
      this.titleval = val.target.value;
      this.showBtn();
      this.reduceRange();
      if (this.titleval.length < 5) {
        return false;
      }
      //  this.saveWriting();
    },
    /**
     * 保存论文
     */
    saveWriting: function() {
      if (this.id == "Examples") {
        return false;
      }
      clearTimeout(this.saveTime);
      this.saveLoading = true;
      this.saveTime = setTimeout(() => {
        this.content = document.getElementById("editor").innerHTML;
        this.textnum = document.getElementById("editor").innerText.length;
        this.api
          .save({
            articleId: this.id,
            title: this.titleval,
            content: this.content,
            lastServerUpdateTime: this.lastServerUpdateTime
          })
          .then(res => {
            if (res.code == 0) {
              this.lastServerUpdateTime = res.data.lastServerUpdateTime;
            }
            if (res.code == 2007) {
              this.$root.stateType.msg = true;
            }
            this.saveLoading = false;
          });
        this.gettitle();
      }, 1000);
    },

    /**
     * 查看查重记录
     */
    golist: function(i) {
      this.checkpage.articleId = this.id;
      if (i) {
        this.checkpage.current = i;
      }
      this.rightDrawer_type = "duplicate";
      this.api.checkList(this.checkpage).then(res => {
        if (res.code == 0) {
          this.checklistData = res.data;
        }
      });
    },
    /**
     * 返回查重
     */
    backlist: function() {
      this.rightDrawer_type = "duplicateCheck";
    },
    /**
     *推荐提纲
     */
    getOuline: function() {
      if (!this.$root.stateType.isLogin) {
        this.getmock().then(res => {
          this.outlineList = res.ouline.data.outlines;
          this.keywords = res.ouline.data.keywords;
          this.ouline_loading = false;
        });

        return false;
      }
      if (
        this.titleval == "" ||
        this.titleval.length < 5 ||
        this.titleval.length > 51
      ) {
        let that = this;
        this.$prompt("输入标题名称", "", {
          closeOnClickModal: false,
          cancelButtonClass: "myno",
          confirmButtonClass: "next",
          confirmButtonText: "确定",
          inputValue: this.titleval,
          inputPlaceholder: "输入关键词或论文标题（建议5-50字）",
          cancelButtonText: "取消",
          inputPattern: /^.{5,51}$/,
          inputErrorMessage: "请输入不少于5字标题",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = false;
              that.titleval = instance.inputValue;
              that.saveWriting();
              that.getOutlineData();
              done();
            } else {
              done();
            }
          }
        }).catch(() => {
          this.museDr();
        });
      } else {
        this.getOutlineData();
      }
    },
    // 获取提纲数据
    getOutlineData: function() {
      this.ouline_loading = true;
      this.menuDrawer = 1;
      this.ouline_type = false;
      this.api
        .outline({
          title: this.titleval,
          keywords: this.keywords
        })
        .then(res => {
          this.outlineList = res.data.outlines;
          this.keywords = res.data.keywords;
          let mgs = `<div style="display: flex; align-items: center;"><img src="/static/images/gou.png" style="margin-right:5px;width:14px;height:14px" alt="" srcset="" /> 已根据您的标题生成了推荐提纲</div>`;
          this.$message({
            dangerouslyUseHTMLString: true,
            iconClass: "none",
            showClose: true,
            message: mgs,
            customClass: "mymessage",
            duration: 2000
          });
        });
      setTimeout(() => {
        this.ouline_loading = false;
      }, 1000);
    },

    /**
     *打开目录
     */
    openMenu: function() {
      this.menuDrawer = 1;
      this.ouline_type = true;
      this.gettitle();
    },
    /**
     * 生成目录
     */
    gettitle: function() {
      clearTimeout(this.settitle);
      this.settitle = setTimeout(() => {
        var dom = document.getElementById("editor").children;
        this.titlelist = [];
        for (let i = 0; i < dom.length; i++) {
          if (
            dom[i].localName == "h1" ||
            dom[i].localName == "h2" ||
            dom[i].localName == "h3"
          ) {
            dom[i].setAttribute("id", i);
            if (dom[i].innerText.length > 1) {
              this.titlelist.push({
                localName: dom[i].localName,
                id:  i,
                content: dom[i].innerText
              });
            } else {
              this.titlelist.push({
                localName: dom[i].localName,
                id:  i,
                content: "未命名标题"
              });
            }
          }
          if (dom[i].localName == "div") {
            dom[i].setAttribute("divcontent", "divContent");
          }
        }
      }, 300);
    },

    /**
     *更新查重
     */
    up_writing: function(look) {
      if (look) {
        this.rightDrawer = 1;
        this.rightDrawer_type = "duplicateCheck";
        setTimeout(() => {
          this.$refs.duplicateCheck.checkDetail();
        }, 500);
      }

      this.api
        .checkDetail({
          articleId: this.id
        })
        .then(res => {
          if (res.code == 0) {
            this.similarJson = res.data;
            if (this.similarJson.checkState == 3) {
              this.similarJson.similarJson = JSON.parse(
                this.similarJson.similarJson
              );
            }
          } else {
          }
        });
    },
    /**
     * 打开右边抽屉栏,
     * @param type[string] 抽屉里面的组件开关
     */
    open_rightDrawer: function(type) {
      if (this.loading) {
        return false;
      }
      if (!this.$root.stateType.isLogin) {
        if (
          type == "errorCorrection" ||
          type == "duplicateCheck" ||
          type == "ai"
        ) {
          this.$message({
            message: "此功能登录才能使用",
            type: "warning"
          });
          return false;
        }
      }

      this.show_note = false;
      if (this.rightDrawer_type != type) {
        this.rightDrawer = 1;
        this.rightDrawer_type = type;
      } else if (this.rightDrawer_type == type) {
        this.rightDrawer == 1 ? (this.rightDrawer = 2) : (this.rightDrawer = 1);
      }

      if (this.rightDrawer_type == "database" && this.rightDrawer == 1) {
        //资料库
        setTimeout(() => {
          this.$refs.database.initData();
        }, 300);
      }
      if (this.rightDrawer_type == "ideas") {
        //智能推荐
        //this.get_ideas();
        if (this.titleval != null && this.titleval.length < 5) {
          this.$message({
            message: "请输入不少于5字标题再试",
            type: "warning"
          });
          this.rightDrawer = 3;
        }
      }
      if (
        this.rightDrawer_type == "errorCorrection" &&
        this.rightDrawer == 1 &&
        this.$refs.eorr
      ) {
        //纠错

        this.$refs.eorr.correctList();
      }
      if (
        this.rightDrawer_type == "duplicateCheck" &&
        this.rightDrawer == 1 &&
        this.$refs.duplicateCheck
      ) {
        this.$refs.duplicateCheck.initData();
      }
      if (this.rightDrawer_type == "ai" && this.rightDrawer == 1) {
        this.getsummary("1");
      }
    },

    backlists(){
      this.$refs.duplicateCheck
    },
    /**
     * 请求资料库
     */
    getDatabase: function() {
      this.Rloading = true;
      setTimeout(() => {
        this.Rloading = false;
      }, 1000);
      this.loadingText = "";
    },

    /**
     * 查看论文详情
     */
    initData: function() {
      this.loading = true;
      if (this.id == "Examples") {
        if (this.$root.stateType.isLogin) {
          this.api.createLogin().then(res => {
            this.titleval = res.data.title;
            this.getOuline();
            setTimeout(() => {
              this.$refs.database.initData();
            }, 100);
          });
        } else {
          this.api.example().then(res => {
            this.titleval = res.data.title;
            this.getOuline();
            setTimeout(() => {
              this.$refs.database.initData();
            }, 100);
          });
        }
        this.menuDrawer = 1;
        this.rightDrawer = 1;
        this.loading = false;
      } else {
        this.api.detail(this.id).then(res => {
          this.loading = false;
          this.titleval = res.data.title;
          this.lastServerUpdateTime = res.data.lastUpdateTimestamp;
          const arr = window.getSelection().focusNode;
          document.getElementById("editor").innerHTML = res.data.content;
          this.jc_btn = false;
          this.textnum = document.getElementById("editor").innerText.length;
          this.gettitle();
        });
      }
    },
    // 标题验证操作
    titleValidate: function() {
      let that = this;
      this.$prompt("输入标题名称", "", {
        closeOnClickModal: false,
        cancelButtonClass: "myno",
        confirmButtonClass: "next",
        confirmButtonText: "确定",
        inputValue: this.titleval,
        inputPlaceholder: "输入关键词或论文标题（建议5-50字）",
        cancelButtonText: "取消",
        inputPattern: /^.{5,51}$/,
        inputErrorMessage: "标题字数需不少于5字",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = false;
            that.titleval = instance.inputValue;
            that.saveWriting();
            done();
          } else {
            done();
          }
        }
      }).catch(() => {
        this.museDr();
      });
    },
    //处理粘贴图片，表格等内容
    handlePaste(e) {
      try {
        let file = e.clipboardData.files[0];
        // 粘贴时，表格，图片返回的type均为image/png
        let isImage = file != undefined && file.type.indexOf("image") != -1;
        // 是否为RTF格式文件
        let pasteRtf = (e.clipboardData || window.clipboardData).getData(
          "text/rtf"
        );
        let isRTF = pasteRtf != undefined && pasteRtf !== "";
        // 是否为纯文本文件
        let pasteTextPlain = (e.clipboardData || window.clipboardData).getData(
          "text/plain"
        );
        let isTextPlain = pasteTextPlain != undefined && pasteTextPlain !== "";
        // 如果是纯文本 则可直接粘贴，如果不是则校验是否是图片，或者是RTF格式文件
        if (!isTextPlain) {
          if (isImage || isRTF) {
            this.$message({
              message: "暂不支持此格式",
              type: "warning"
            });
            // 阻止事件传递
            e.preventDefault();
          }
        }
      } catch (e) {
        this.$message({
          message: "暂不支持此格式",
          type: "warning"
        });
        e.preventDefault();
      } finally {
      }
    },

    /** 获取论文导出次数 */
    getExportTimes() {
      this.api.getToolsLimitCheck({ type: 2 }).then(res => {
        if (res.code == 0) {
          this.exportTimes = 1;
        } else {
          this.exportTimes = 0;
        }
      });
    },
    closeRechargePop(dialogVisible) {
      this.dialogVisible = dialogVisible;
    },
    paySuccess() {
      this.dialogVisible = false;
      this.vipPop = true;
      // 更新用户信息
      this.oauthapi.userInfo().then(res => {
        this.userinfo = res.data;
        this.expireTime = this.userinfo.expireTime;
      });
    },
    /** 获取查重向导限制 */
    getGuideLimit() {
      this.api.getGuideLimit({ type: 2 }).then(res => {
        if (res.code == 0) {
          if (res.data) {
            let checkBtn = document.getElementById("checkBtn");
            let menuRight = document.getElementsByClassName("menuRight")[0];

            menuRight.style = "z-index:8888;background:rgba(255,255,255,0.2)";
            // menuRightImg.style = "optcity:0.2optcity:0.2"
            // console.log(menuRightImg)
            this.isClass = true
            checkBtn.style = "z-index:9999;background:#ffffff";
            const h = this.$createElement;
            var that = this
            this.$msgbox({
              title: "查重步骤",
              message: "2. 点击[实时查重]即可开始",
              customClass: "import-guide-check",
              confirmButtonText: "知道了",
              confirmButtonClass: "import-guide-btn",
              roundButton: true,
              distinguishCancelAndClose: true,
              beforeClose: (action, instance, done) => {
                if (action === "confirm") {
                  done();
                  checkBtn.click();
                  this.isClass = false
                  checkBtn.style = "z-index:9999;background:none";
                } else {
                  done();
                  that.isClass = false
                  checkBtn.style = "z-index:9999;background:none"
                }
              }
            }).then(action => {

            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$rWidth: 620px;
$lWidth: 340px;

.isClassOn{
  opacity: 0.2;
}

.mgs_golink {
  position: fixed;
  z-index: 99999;
  left: 40%;
  top: 54px;
  background: #ffffff;
  transition: top 0.3s;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  color: #66686e;
  border: 1px solid #cccccc;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);

  button {
    color: #c79758;
    background: none;
    border: none;
  }
}

.jc_box {
  width: 360px;
  position: absolute;
  z-index: 3;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(51, 52, 57, 0.2);
  border-radius: 4px;
  transition: left 0.3s, top 0.3s;

  p {
    font-size: 14px;
    color: #333439;
    margin: 16px;
  }

  .row {
    display: flex;
    justify-content: space-between;
    padding: 10px 16px;
    border-top: 1px solid #f5f6fa;

    .close {
      font-size: 14px;
      color: #989da2;
      background: #f5f6fa;
      border-radius: 12px;
      border: none;
    }

    .real_text {
      font-size: 14px;
      background: #ecf7fe;
      border-radius: 12px;
      color: #5576bd;
      margin-left: 12px;
      border: none;
    }

    span {
      font-size: 12px;
      color: #989da2;
      line-height: 22px;

      b {
        font-size: 12px;
        color: #ff5959;
      }
    }
  }
}

.noshow {
  position: fixed;
  z-index: 0;
  left: 40%;
  top: -100px;
  background: #ffffff;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  color: #66686e;
  border: 1px solid #cccccc;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
}

.note_edit {
  display: flex;
  justify-content: space-between;
}

.lookW {
  width: 400px;
  animation: alookW 0.3s;
}

.mosuW {
  width: 0px;
  overflow: hidden;
  animation: amosuW 0.3s;
}

@keyframes amosuW {
  from {
    width: 400px;
  }

  to {
    width: 0px;
  }
}

@keyframes alookW {
  from {
    width: 0px;
  }

  to {
    width: 400px;
  }
}

.default {
  width: 20px;
  height: 20px;
  background: url("/static/images/zidongjiangchong_default.png") no-repeat;
}

.jc_btn {
  position: absolute;
  display: flex;
  background: #333439;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 98px;
  height: 88px;
  background: url("/static/images/popup_zidongjiangchong.png") no-repeat;

  button {
    background: none;
    font-size: 12px;
    color: #cccedc;
    width: 88px;
    border: none;
  }
}

.open_npte {
  position: absolute;
  bottom: 74px;
  right: -87px;
  z-index: 3;
}

.gou_box {
  width: 20px;
  display: inline-block;
  height: 20px;
  margin-right: 5px;

  i {
    margin-right: 0;
  }
}

.ai_btn {
  border: none;
  background: $btnc;
  color: #ffffff;
  border-radius: 4px;
  font-size: 12px;
}

.titlelist {
  overflow: auto;
  height: calc(100vh - 159px);
  padding-bottom: 16px;

  ul {
    padding: 0;
    cursor: pointer;
    li {
      margin-top: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .h1 {
      font-size: 14px;
      font-weight: bold;
      color: #66686e;
    }

    .h2 {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }
  }
}

#editor:empty:not(:focus)::before {
  content: "请输入论文内容";
  opacity: 0.5;
}

.miniSize {
  font-size: 12px;
  color: #989ea2;
}

.update {
  background: none;
  border: none;
  color: $btnc;
  margin-left: 50px;
}

.Right_icon_box {
  width: 48px;
  height: 48px;
  margin: 0 auto;
}

.oulinebtn {
  position: absolute;
  width: 84px;
  height: 28px;
  background: #ffffff;
  border: 1px solid #5676be;
  box-shadow: 0px 0px 8px 0px rgba(102, 151, 255, 0.5);
  border-radius: 14px;
  color: #5676be;
}

.oulinebtn:hover {
  border: none;
  color: #ffffff;
  background: $btnc;
}

.editor {
  background: #f5f6fa;
  height: calc(100vh - 2px);
  overflow: hidden;

  .acv {
    background: #e2e3e7 !important;
  }

  .nav {
    background: #ffffff;
    height: 56px;
    display: flex;
    align-items: center;
    padding: 0 40px;
    justify-content: center;
    box-shadow: 0px 0px 8px 0px rgba(52, 52, 58, 0.1);
    z-index: 1;
    position: relative;
    min-width: $mWidth;

    .nav_box {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .navLeft {
      display: flex;
      align-items: center;
    }

    .back {
      font-size: 16px;
      margin-right: 10px;
    }

    .text {
      font-size: 12px;
      font-weight: 400;
      color: #989ea2;
      margin-left: 40px;
      display: flex;
      align-items: center;
      display: flex;
      align-items: center;

      i {
        margin-left: 4px;
        margin-top: 2px;
      }
    }

    .el-dropdown {
      font-size: 14px;
      color: #000000;
      font-weight: bold;
      display: flex;
      align-items: center;
      outline: none;
      cursor: pointer;
    }

    .el-dropdown:focus {
      outline: 0;
    }

    .el-dropdown-link {
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100px;
        display: inline-block;
      }
    }

    .navRight {
      display: flex;
      align-items: center;

      .dow {
        background: none;
        border: none;
        display: flex;
        align-items: center;
        margin-right: 15px;

        img {
          margin-right: 5px;
        }
      }

      .userimg {
        width: 32px;
        height: 32px;
        border-radius: 32px;
      }
    }
  }

  .editbox {
    min-width: $mWidth;
    position: relative;
    height: calc(100vh - 56px);

    .menubtn {
      border: none;
      background: none;
      position: fixed;
      left: -10px;
      top: 104px;
      z-index: 9;
    }

    .menuRight {
      right: 0;
      height: calc(100vh - 56px);
      background: #ffffff;
      width: 80px;
      text-align: center;
      cursor: pointer;

      div {
        margin-top: 33px;
      }

      p {
        color: $btnc;
      }
    }

    .btnrow {
      height: 48px;
      display: flex;
      align-items: center;
      position: relative;

      .fl_left {
        color: #989ea2;
        position: absolute;
        right: 0;

        img {
          margin-left: 4px;
        }
      }

      .ounline {
        background: linear-gradient(0deg, #5676bd 0%, #7395de 100%);
        border-radius: 30px;
        color: #ffffff;
        font-size: 14px;
        font-weight: 400;
        padding: 4px 8px;
        border: none;
      }

      .edit_btn {
        margin-left: 20px;
        display: flex;
        align-items: center;

        button {
          border: none;
          background: none;
          font-size: 16px;
          color: #66686e;
        }

        .shu {
          display: inline-block;
          height: 16px;
          width: 1px;
          background: #ccc;
          margin: 0 10px;
        }
      }
    }

    .edit {
      height: calc(100vh - 56px);
      background: #f5f6fa;
      width: 820px;
      position: relative;

      .content {
        background: #ffffff;
        padding: 43px;
        box-shadow: 0px 0px 8px 0px rgba(51, 51, 57, 0.1);
        overflow: auto;
        height: calc(100vh - 191px);

        .title {
          width: 100%;
          font-size: 28px;
          font-weight: bold;
          border: none;
          outline: none;
          background-color: transparent;
          color: inherit;
          border-color: inherit;
        }

        .line {
          border-top: 1px solid #f2f2f2;
          margin-top: 1rem;
        }

        #editor {
          margin-top: 20px;
          outline: none;
          font-size: 14px;
          min-height: calc(100vh - 268px);
          word-wrap: break-word;

          h1 {
            font-size: 24px !important;
          }

          div {
            letter-spacing: 1px;
            line-height: 28px;
          }
        }

        input::-webkit-input-placeholder {
          color: #9b9b9b;
        }
      }
    }

    .openmenuDrawer {
      position: fixed;
      height: calc(100vh - 66px);
      width: $lWidth;
      top: 66px;
      animation: openlmenuDrawer 0.3s;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      z-index: 10;
    }

    .menuDrawer {
      position: fixed;
      height: calc(100vh - 66px);
      width: 0px;
      top: 66px;
      animation: lmenuDrawer 0.3s;
      background: #ffffff;
      overflow: hidden;
      z-index: 10;
    }

    .openrightDrawer {
      height: calc(100vh - 55px);
      width: $rWidth;
      overflow: hidden;
      animation: openmenuDrawer 0.3s;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(52, 52, 58, 0.1);
    }

    .rightDrawer {
      height: calc(100vh - 56px);
      width: 0px;
      animation: menuDrawer 0.3s;
      background: #ffffff;
      overflow: hidden;
    }

    .left_hover {
      margin-top: calc(50vh - 73px);
      margin-right: -8px;
    }

    .left_right_hover {
      right: 72px;
      top: calc(50% - 40px);
      z-index: 3;
    }

    .images_right {
      display: inline-block;
      height: 63px;
      width: 31px;
      background: url("/static/images/right_default.png");
    }

    .images_right:hover {
      background: url("/static/images/right_hover.png");
    }

    .images_left {
      display: inline-block;
      height: 63px;
      width: 31px;
      background: url("/static/images/left_default.png");
    }

    .images_left:hover {
      background: url("/static/images/left_hover.png");
    }

    .right_hover {
      margin-top: calc(50vh - 73px);
      margin-right: -8px;
    }

    .oulinebox {
      width: $lWidth - 24;
      width: 315px;
      padding: 16px 4px 16px 16px;

      .menu_row {
        display: flex;
        justify-content: space-between;
        color: #989ea2;
      }
    }

    .menu_box {
      width: $lWidth - 32;
      padding: 16px;

      .menu_row {
        display: flex;
        justify-content: space-between;
        color: #989ea2;
      }

      .menu_hr {
        border: 1px solid #f5f6fa;
        margin-top: 16px;
      }

      .no_title {
        text-align: center;
        margin-top: 150px;

        p {
          color: #989ea2;
        }

        h5 {
          font-weight: 400;
          color: #66686e;
          margin-top: 60px;
        }

        button {
          width: 84px;
          height: 28px;
          background: $btnc;
          border-radius: 14px;
          color: #ffffff;
          margin-top: 12px;
        }
      }
    }
  }

  // 个人中心样式
  .login {
    width: 102px;
    color: #ffffff;
    height: 33px;
    background: $btnc;
    opacity: 1;
    border-radius: 20px;
    border: none;
    font-size: 16px;
    line-height: 33px;
    z-index: 9;
    cursor: pointer;
  }

  .head-avatar {
    cursor: pointer;
  }

  .dropdown-ava {
    overflow: hidden !important;
    padding-top: 10px !important;
  }

  .avatar-l {
    float: left !important;
  }

  .avatar-r {
    float: left !important;
    margin-left: 10px !important;
    line-height: 25px !important;

    .avatar-r-txt {
      span {
        margin-left: 10px !important;
        color: #c79757 !important;
        cursor: pointer !important;
      }
    }
  }

  @keyframes openlmenuDrawer {
    from {
      width: 0px;
    }

    to {
      width: $lWidth;
    }
  }

  @keyframes lmenuDrawer {
    from {
      width: $lWidth;
    }

    to {
      width: 0px;
    }
  }

  @keyframes openmenuDrawer {
    from {
      width: 0px;
    }

    to {
      width: $rWidth;
    }
  }

  @keyframes menuDrawer {
    from {
      width: $rWidth;
    }

    to {
      width: 0px;
    }
  }

  @keyframes left_hover {
    from {
      right: $rWidth + 72;
    }

    to {
      right: 72px;
    }
  }

  @keyframes right_hover {
    from {
      right: 72px;
    }

    to {
      right: $rWidth + 72;
    }
  }
}

.limit-open-vip {
   /deep/ .el-dialog__title{
     font-weight: bold;
   }
 }

 .open-vip-box{
    display:flex;
    flex-direction: column;
    align-items:center;
    justify-content:space-between;

    .open-vip-box-message{
      margin-bottom: 20px;
    }

    .check-glod-btn {
      width: 134px;
      height: 36px;
      background: #c79758;
      opacity: 1;
      border-radius: 18px;
      border: none;
    }
    .check-btn-text {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 12px;
      color: #ffffff;
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/editor/editor.vue